export const currencyOptions = [
  { label: 'USD ($)', value: 'USD' },
  { label: 'CLP ($)', value: 'CLP' },
  { label: 'BRL (R$)', value: 'BRL' }
]; 